import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["SavedView"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSavedView: build.query<GetSavedViewApiResponse, GetSavedViewApiArg>({
        query: () => ({ url: `/SavedView` }),
        providesTags: ["SavedView"],
      }),
      postSavedView: build.mutation<
        PostSavedViewApiResponse,
        PostSavedViewApiArg
      >({
        query: (queryArg) => ({
          url: `/SavedView`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["SavedView"],
      }),
      putSavedViewById: build.mutation<
        PutSavedViewByIdApiResponse,
        PutSavedViewByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/SavedView/${queryArg.id}`,
          method: "PUT",
          body: queryArg.configurationDto,
        }),
        invalidatesTags: ["SavedView"],
      }),
      deleteSavedViewById: build.mutation<
        DeleteSavedViewByIdApiResponse,
        DeleteSavedViewByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/SavedView/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["SavedView"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as savedViewApi };
export type GetSavedViewApiResponse =
  /** status 200 OK */ DeletableConfigurationDto[];
export type GetSavedViewApiArg = void;
export type PostSavedViewApiResponse = /** status 201 Created */ number;
export type PostSavedViewApiArg = ConfigurationDto;
export type PutSavedViewByIdApiResponse = /** status 200 OK */ void;
export type PutSavedViewByIdApiArg = {
  id: number;
  configurationDto: ConfigurationDto;
};
export type DeleteSavedViewByIdApiResponse = unknown;
export type DeleteSavedViewByIdApiArg = number;
export type DeletableConfigurationDto = {
  id: number;
  category: string;
  name: string;
  value: string;
  isDefault: boolean;
  isDeletable: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type ConfigurationDto = {
  id: number;
  category: string;
  name: string;
  value: string;
  isDefault: boolean;
};
export const {
  useGetSavedViewQuery,
  useLazyGetSavedViewQuery,
  usePostSavedViewMutation,
  usePutSavedViewByIdMutation,
  useDeleteSavedViewByIdMutation,
} = injectedRtkApi;
